import { Component, TemplateRef, ViewChild } from '@angular/core'
import { EventColor } from 'calendar-utils'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/store/state/app.state'
import { Observable, Subject, Subscription } from 'rxjs'
import { DashboardState } from '../../store/state/dashboard.state'
import { getUserDashboardState } from '../../store/selector/dashboard.selector'
import { CalendarEvent, CalendarView } from 'angular-calendar'
import * as moment from 'moment'
import { DashboardService } from 'src/app/services/dashboard/dashboard.service'
import { ViewForSelectorComponent } from '../common/view-for-selector/view-for-selector.component'
import { CalendarEventAPIModel, DocumentAPIModel, UserAPIModel } from 'src/app/models/api.model'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { getSelectedCompaniesFromState, getUserFromState } from 'src/app/store/selector/initialize.selector'
import { DynamicComponentLoaderService } from 'src/app/services/dynamic-component-loader/dynamic-component-loader.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import { DocumentService } from 'src/app/services/common/document.service'
import { DomSanitizer } from '@angular/platform-browser'

const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
}

@Component({
  selector: 'app-compliance-dashboard',
  templateUrl: './compliance-dashboard.component.html',
  styleUrls: ['./compliance-dashboard.component.scss']
})
export class ComplianceDashboardComponent {
  readonly DASHBOARD = `/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly ACTIVITY_DASHBOARD = `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly QUERY_DASHBOARD = `/${GlobalConstants.ROUTING.QUERY}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly GOVERNMENT_BUSINESS_DASHBOARD = `/${GlobalConstants.ROUTING.GOVERNMENT_BUSINESS}/${GlobalConstants.ROUTING.DASHBOARD}`
  readonly PROFILE = `/${GlobalConstants.ROUTING.PROFILE}`
  readonly SETTINGS = `/${GlobalConstants.ROUTING.SETTINGS}`
  readonly KNOWLEDGE_HUB = `/${GlobalConstants.ROUTING.KNOWLEDGE_HUB}/${GlobalConstants.ROUTING.SEARCH}`
  readonly PENDING_ITEM = `/${GlobalConstants.ROUTING.ACTIVITY}/${GlobalConstants.ROUTING.PENDING}`
  readonly ANNOUNCEMENT = `/${GlobalConstants.ROUTING.ANNOUNCEMENT}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly REPOSITORY = `/${GlobalConstants.ROUTING.DATA_REPOSITORY}/${GlobalConstants.ROUTING.QUICK_SELECT}`
  readonly CALENDER = `/${GlobalConstants.ROUTING.CALENDAR_INFO}/${GlobalConstants.ROUTING.SUMMARY}`
  readonly EMPLOYEE = `/${GlobalConstants.ROUTING.EMPLOYEE_INFO}/${GlobalConstants.ROUTING.SUMMARY}`

  isEnitiyWiseInfoVisible: boolean = false

  constructor(
    private appState: Store<AppState>,
    private dashboardService: DashboardService,
    private dynamicComponentLoaderService: DynamicComponentLoaderService,
    private documentService: DocumentService,
    protected _sanitizer: DomSanitizer
  ) {
    this.userDashboardDetails$ = this.appState.select(getUserDashboardState)
    this.selectedCompaniesSubscription = this.appState
      .select(getSelectedCompaniesFromState)
      .subscribe(selectedCompanies => {
        if (selectedCompanies) {
          this.companyName = selectedCompanies?.filter(sc => sc?.showOnUIHeader)?.[0]?.name
        }
      })
  }

  companyName = 'Select Client'
  userDashboardDetails$: Observable<DashboardState>
  selectedCompaniesSubscription: Subscription
  calendarEvents: CalendarEventAPIModel[] = []
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>
  view: CalendarView = CalendarView.Month
  statisticsType = GlobalConstants.STATISTICS

  CalendarView = CalendarView

  viewDate = new Date()

  refresh = new Subject<void>()

  events: CalendarEvent[] = []

  activeDayIsOpen: boolean = false

  user$: Observable<UserAPIModel>
  dashboard = {
    displayAnnouncementModel: {
      show: false,
      content: undefined,
      title: '',
      isAttachmentDocumentAvailable: false,
      attachments: [],
      companyId: ''
    },
    displayCalendarModel: {
      show: false,
      content: [],
      title: '',
      date: ''
    }
  }

  ngOnInit() {
    this.user$ = this.appState.select(getUserFromState)
    this.getCalendarEvent()
    this.dispatDashboardLoadAction()
  }

  dispatDashboardLoadAction() {
    this.dashboardService.dispatchDashboardLoadAction(null, null)
  }

  getCalendarEvent() {
    this.userDashboardDetails$.subscribe(dashboardDetail => {
      if (
        dashboardDetail?.announcements?.length > 0 ||
        dashboardDetail?.calendarEvents?.length > 0 ||
        dashboardDetail?.statistics?.length > 0
      ) {
        this.calendarEvents = dashboardDetail?.calendarEvents
        if (this.calendarEvents?.length > 0) {
          this.buildEventDisplayIconOnCalendar(this.calendarEvents)
        }
      }
    })
  }

  buildEventDisplayIconOnCalendar(calendarEvents) {
    const calendarEvent = []
    const uniqueDateAndreferenceType = []
    calendarEvents.forEach(obj => {
      const date = moment(obj.dueDatetime).format(GlobalConstants.DATEFORMAT)
      const referenceType = obj.referenceType
      const isDuplicate = uniqueDateAndreferenceType.some(
        item =>
          moment(item.dueDatetime).format(GlobalConstants.DATEFORMAT) === date && item.referenceType === referenceType
      )
      if (!isDuplicate) {
        uniqueDateAndreferenceType.push(obj)
      }
    })
    uniqueDateAndreferenceType.forEach(calEvent => {
      calendarEvent.push({
        id: calEvent.displayId,
        start: new Date(calEvent.dueDatetime),
        color:
          calEvent.referenceType == 'ACTIVITY'
            ? { ...colors['blue'] }
            : calEvent.referenceType == 'QUERIES' || !calEvent.referenceType
            ? { ...colors['yellow'] }
            : { ...colors['red'] }
      })
    })
    this.events = calendarEvent
    this.refresh.next()
  }

  displayNotificationDetails(data) {
    const displayAnnouncementModel = {
      show: true,
      content: this._sanitizer.bypassSecurityTrustHtml(data.description),
      title: data.heading,
      isAttachmentDocumentAvailable: data.documents?.length > 0,
      attachments: data?.documents || [],
      companyId: data.companyEntityId
    }

    this.dashboard.displayAnnouncementModel = displayAnnouncementModel
  }

  closeAnnouncementPopup() {
    this.dashboard.displayAnnouncementModel = {
      show: false,
      attachments: [],
      content: undefined,
      isAttachmentDocumentAvailable: false,
      title: '',
      companyId: ''
    }
  }

  closeCalendarPopup() {
    this.dashboard.displayCalendarModel = {
      show: false,
      content: [],
      title: '',
      date: ''
    }
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false
  }

  openEventDetailsPopup(ev) {
    const calendarDisplayData = this.calendarEvents.find(res => {
      return res.displayId == ev.event.id
    })

    const displayData = this.calendarEvents.filter(item => {
      return (
        moment(item.dueDatetime).format(GlobalConstants.DATEFORMAT) ===
          moment(calendarDisplayData.dueDatetime).format(GlobalConstants.DATEFORMAT) &&
        item.referenceType === calendarDisplayData.referenceType
      )
    })

    const displayCalendarModel = {
      show: true,
      content: displayData,
      title: calendarDisplayData.referenceType,
      date: calendarDisplayData.dueDatetime
    }

    this.dashboard.displayCalendarModel = displayCalendarModel
  }

  handleViewForData($event: any) {
    this.dashboardService.dispatchDashboardLoadAction($event.begin, $event.end)
  }

  openClientSelector() {
    this.dynamicComponentLoaderService.loadComponent(GlobalConstants.DYNAMIC_MODEL.CLIENT_SELECTOR.key)
  }

  downloadDocument = (document: DocumentAPIModel, companyEntityId: string) => {
    const endPoint = `${ServiceUrlConstants.API_DOWNLOAD_DELETE_DOCUMENT}${document.id}`
    this.documentService.downloadDocument(endPoint)
  }

  generateLink(data): string {
    if (data && data.referenceType && data.referenceId && data.referenceDisplayId) {
      const taskType = data.referenceType.includes('_') ? data.referenceType.replace(/_/g, '-') : data.referenceType
      const href = `${taskType.toLowerCase()}/${data.referenceId}/details`
      const link = `<a href="${href}">${data.referenceDisplayId}</a>`

      return link
    } else {
      return ''
    }
  }

  openEntityWiseInfoModal() {
    this.isEnitiyWiseInfoVisible = true
  }

  closeEntityWiseInfoModal() {
    this.isEnitiyWiseInfoVisible = false
  }

  ngOnDestroy() {
    this.selectedCompaniesSubscription?.unsubscribe()
  }
}
